(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('recommendInnerService', recommendInnerService);

    function recommendInnerService() {
        var service = {
        };
        return service;
    }
})();